








import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'bank-accounts-view',
})
export default class BankAccountsView extends Vue { }
